export default __webpack_public_path__ + "static/media/curvedSocial.f704038e.svg";